module.exports = __webpack_public_path__ + "static/img/bg-overview@t.9b4903a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgwatersolution/bg-overview@t.jpg
// module id = P6x1
// module chunks = 0